<template>
  <b-form-group label="Vacina" label-for="vacina" label-class="font_size_label vacina">
    <validation-provider #default="{ errors }" name="Vacina">
      <v-select
        id="vacina"
        :options="options"
        v-model="selected"
        placeholder="Selecione uma vacina"
        label="descricao"
        :clearable="true"
        multiselect
        multiple
      >
        <template #list-header v-if="ehMultiplo && options.length > 0">
          <div class="vs__dropdown-option" @click="toggleSelectAll">
            <input type="checkbox" class="mr-1" :checked="isAllSelected" @click.stop="toggleSelectAll"/>
            <span>Selecionar Todas</span>
          </div>
        </template>
        <span slot="no-options">Nenhuma opção selecionável.</span>
      </v-select>
      <small v-if="errors[0]" class="text-danger">
        {{ errors[0] }}
      </small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import {
  BForm,
  BCol,
  BRow,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BSpinner,
  BFormDatepicker,
  BFormTextarea,
  BOverlay,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";

export default {
  components: {
    BForm,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BSpinner,
    BFormDatepicker,
    BFormTextarea,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  props: {
    value: {
      required: true,
    },
    optionsConsulted: {
      required: false,
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      options: [],
      selected: this.value,
      parametros: {
        params: {
          paginacao: false,
          ordem: 'desc',
        },
      },
    };
  },
  beforeMount() {
    this.setOptions();
  },
  methods: {
    async setOptions() {
      if (this.optionsConsulted.length > 0) {
        this.options = this.optionsConsulted;
        return;
      }

      await this.$http
        .get(this.$api.saveAndGetVacina(), this.parametros)
        .then(({ data }) => {
          this.options = data.map((vacina) => {
            return {
              id_vacina: vacina.id_vacina,
              descricao: vacina.nome_tecnico_vacina,
            }
          });
        });
    },

    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selected = [];
      } else {
        this.selected = [...this.options];
      }
    },
  },
  watch: {
    selected: function (valor) {
      this.$emit("selected", valor);
    },
    options: function (valor) {
      this.$emit("options", valor);
    },
  },

  computed: {
    ehMultiplo() {
      return this.options.length > 1;
    },
    isAllSelected() {
      return this.selected && this.selected.length === this.options.length;
    }
  },
};
</script>

